import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import iconDelete from 'assets/svgicon/icon-delete.svg';
import iconMail from 'assets/svgicon/icon-mail-big.svg';
import iconMap from 'assets/svgicon/icon-map-big.svg';
import Icon, { IconList } from 'components/Icon';
import { ITEM_NUM_PER_PAGE, ITEM_NUM_PER_PAGE_CAMERA_SENSOR, SENSOR_STATUS_ALERT } from 'constants/config';
import { TEXT_DATA_RECEIVED_DATETIME, TEXT_ELTRES_ID, TEXT_FLOOD_GATE_OPENING_LEVEL, TEXT_GROUP_ID, TEXT_INNER_WATER_LEVEL, TEXT_LATITUDE, TEXT_LOCATION, TEXT_LONGITUDE, TEXT_MANAGEMENT_ID, TEXT_MESSAGE, TEXT_NAME, TEXT_OUTER_WATER_LEVEL, TEXT_POWER_VOLTAGE, TEXT_REGISTERED_DATE, TEXT_SENSOR_TYPE, TEXT_STATUS, TEXT_VALUE } from 'constants/message';
import { useGeneralSetting } from 'context/GeneralSettingContext';
import { useSensorGroups } from 'context/SensorGroupsContext';
import { LockState, SensorType, SensorTypeName } from 'models';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { ROLE, SENSOR_PROPERTIES, TEXT_SEND_MAIL, TEXT_VIEW_MAP, UNDEFINED_TEXT } from 'utils/constanst';
import { hexToRGB } from 'utils/function';
import BaseList from '../../../components/BaseList';
import "./SensorDetailList.css";
import CameraDisplayer from 'pages/components/CameraDisplayer';

const IconValue = {
  'iconMail': iconMail,
  'iconMap': iconMap,
  'iconDelete': iconDelete
}

const HEADER = [
  { id: SENSOR_PROPERTIES.MANAGE_ID, label: TEXT_MANAGEMENT_ID, role: ROLE.GENERAL, width: '120px', isSort: true },
  { id: SENSOR_PROPERTIES.NAME, label: TEXT_NAME, role: ROLE.GENERAL },
  { id: SENSOR_PROPERTIES.GROUP_ID, label: TEXT_SENSOR_TYPE, role: ROLE.MANAGE, width: '100px' },
  { id: SENSOR_PROPERTIES.LOCATION, label: TEXT_LOCATION, role: ROLE.GENERAL },
  { id: SENSOR_PROPERTIES.TX, label: TEXT_DATA_RECEIVED_DATETIME, role: ROLE.LIST, width: '160px' },
  { id: SENSOR_PROPERTIES.STATUS, label: TEXT_STATUS, role: ROLE.LIST, isSort: true },
  { id: SENSOR_PROPERTIES.FLOOD_GATE_OPENING_LEVEL, label: TEXT_FLOOD_GATE_OPENING_LEVEL, role: ROLE.LIST, width: '80px' },
  { id: SENSOR_PROPERTIES.OUTER_WATER_LEVEL, label: TEXT_OUTER_WATER_LEVEL, role: ROLE.LIST, width: '80px' },
  { id: SENSOR_PROPERTIES.INNER_WATER_LEVEL, label: TEXT_INNER_WATER_LEVEL, role: ROLE.LIST, width: '80px' },
  { id: SENSOR_PROPERTIES.POWER_VOLTAGE, label: TEXT_POWER_VOLTAGE, role: ROLE.LIST, width: '80px' },
  { id: SENSOR_PROPERTIES.MESSAGE, label: TEXT_MESSAGE, role: ROLE.LIST },
  { id: 'iconMail', label: TEXT_SEND_MAIL, role: ROLE.LIST, width: '80px' },
  { id: 'iconMap', label: TEXT_VIEW_MAP, role: ROLE.LIST, width: '80px' },

  { id: SENSOR_PROPERTIES.CREATEDAT, label: TEXT_REGISTERED_DATE, role: ROLE.MANAGE, width: '120px' },
  { id: SENSOR_PROPERTIES.ID, label: TEXT_ELTRES_ID, role: ROLE.MANAGE, width: '140px', isSort: true },
  { id: SENSOR_PROPERTIES.API_GROUP_ID, label: TEXT_GROUP_ID, role: ROLE.MANAGE, width: '140px', isSort: true },
  { id: SENSOR_PROPERTIES.LAT, label: TEXT_LATITUDE, role: ROLE.MANAGE, width: '80px', isSort: true },
  { id: SENSOR_PROPERTIES.LONG, label: TEXT_LONGITUDE, role: ROLE.MANAGE, width: '80px', isSort: true },
  { id: 'iconDelete', label: '', role: ROLE.MANAGE, width: '60px' },

  { id: SENSOR_PROPERTIES.TX, label: TEXT_DATA_RECEIVED_DATETIME, role: ROLE.DETAIL },
  { id: SENSOR_PROPERTIES.STATUS, label: TEXT_STATUS, role: ROLE.DETAIL },
  { id: '', label: TEXT_VALUE, role: ROLE.DETAIL },
]

const propTypes = {
  sensorType: PropTypes.oneOf([SensorType.FLOOD, SensorType.FLOOD_GATE, SensorType.CAMERA, SensorType.GENERAL]),
  items: PropTypes.arrayOf(PropTypes.object),
  isManagementList: PropTypes.bool,
  curPage: PropTypes.number,
  onEditItem: PropTypes.func,
  onDeleteItem: PropTypes.func,
  onViewItem: PropTypes.func,
  onSendMail: PropTypes.func,
  onFocusItem: PropTypes.func,
  onPageChange: PropTypes.func,
  functionBtn: PropTypes.func,
};
const defaultProps = {
  sensorType: SensorType.FLOOD,
  items: [],
  isManagementList: false,
  onEditItem: (item) => { },
  onDeleteItem: (item) => { },
  onViewItem: (item) => { },
  onSendMail: (item) => { },
  onFocusItem: (item) => { },
  onPageChange: (newPage) => { }
};

const SensorDetailList = (props) => {
  /*** States and Variables ***/
  const { sensorGroups } = useSensorGroups();
  const { generalSetting } = useGeneralSetting();
  const [sortedItems, setSortedItems] = React.useState([]);
  const [orderBy, setOrderBy] = React.useState(SENSOR_PROPERTIES.MANAGE_ID);
  const [descDirections, setDescDirections] = React.useState([]);
  const [quickViewItem, setQuickViewItem] = React.useState(null);

  /*** Processing ***/
  React.useEffect(() => {
    const newItems = [...props.items];
    if (props.items.length) {
      if (descDirections.includes(orderBy)) {
        if (typeof (props.items[0][orderBy]) === 'string') {
          newItems.sort((x, y) => -x[orderBy].localeCompare(y[orderBy]));
        }
        else if (typeof (props.items[0][orderBy]) === 'number') {
          newItems.sort((x, y) => {
            if (x[orderBy] > y[orderBy]) return -1;
            if (x[orderBy] < y[orderBy]) return 1;
            return 0;
          });
        }
      }
      else {
        if (typeof (props.items[0][orderBy]) === 'string') {
          newItems.sort((x, y) => x[orderBy].localeCompare(y[orderBy]));
        }
        else if (typeof (props.items[0][orderBy]) === 'number') {
          newItems.sort((x, y) => {
            if (x[orderBy] > y[orderBy]) return 1;
            if (x[orderBy] < y[orderBy]) return -1;
            return 0;
          });
        }
      }
    }
    setSortedItems(newItems);
  }, [props.items, orderBy, descDirections])

  /*** Sub Components ***/
  const renderHeader = () => {
    if (props.sensorType === SensorType.CAMERA && !props.isManagementList) return <></>
    return <div className='sensor_detail_list_header'>
      {
        HEADER
          .filter((item) => isValidationColumn(item))
          .map((item, index) => {
            if (item.id.startsWith('data') && props.sensorType !== SensorType.FLOOD_GATE && item.id !== 'data.powerVoltage') return null;
            return <div
              key={index}
              className='sensor_detail_list_header_cell'
              style={{
                cursor: item.isSort ? 'pointer' : 'default',
                justifyContent: item.id.includes('icon') ? 'center' : 'flex-start'
              }}
              onClick={() => { if (item.isSort) onChangeOrderBy(item.id) }}
            >
              {item.label}
              {item.isSort &&
                <Icon
                  icon={IconList.iconSort}
                  iconStyle={
                    (orderBy === item.id ? 'sensor_detail_list_active_sort_direction ' : 'sensor_detail_list_inactive_sort_direction ') +
                    (descDirections.includes(item.id) ? 'sensor_detail_list_sort_desc_direction' : 'sensor_detail_list_sort_asc_direction')} />}
            </div>
          })
      }
    </div>
  }

  const renderItem = (sensor) => {
    const targetGroup = sensorGroups.find(g => g.id === sensor.groupId);
    const alertMessage = targetGroup?.messages?.find(m => m?.value === SENSOR_STATUS_ALERT);
    const statusColor = targetGroup?.messages?.[sensor.status]?.color;
    const sensorData = sensor.data;
    if (targetGroup?.type === SensorType.CAMERA && !props.isManagementList) {
      const isDoubleCamera = sensorData.typeCamera === "DOUBLE";
      const isSwap = sensorData.swapImageCamera;
      // return <CameraDisplayer
      //   sensorId={sensor.id}
      //   isDisplayVideo={sensorData.typeDisplayCamera === "VIDEO"}
      //   isImageAnalysis={sensorData.imageAnalysisFeature}
      //   isSwap={sensorData.swapImageCamera}
      //   isDouble={sensorData.typeCamera === "DOUBLE"}
      //   isInList
      //   label={sensor.name}
      //   style={{ width: 'unset' }}
      //   onClick={onClickSensor}
      //   imageProps={{
      //     key1: sensorData.keyNewestImage,
      //     key2: sensorData.keyNewestImage2,
      //   }}
      //   buttonStatusProps={{
      //     status: {
      //       camera1: {
      //         color: targetGroup.messages[sensorData.imageAnalysisLastFloodDetectedStatus_1]?.color,
      //         value: targetGroup.messages[sensorData.imageAnalysisLastFloodDetectedStatus_1]?.value
      //       },
      //       camera2: {
      //         color: targetGroup.messages[sensorData.imageAnalysisLastFloodDetectedStatus_2]?.color,
      //         value: targetGroup.messages[sensorData.imageAnalysisLastFloodDetectedStatus_2]?.value
      //       }
      //     },
      //     toolTipContent: {
      //       camera1: sensorData.imageAnalysisResponse_1,
      //       camera2: sensorData.imageAnalysisResponse_2
      //     }
      //   }}
      // />
      return <React.Fragment>
        {/* Camera 1 */}
        <CameraDisplayer
          targetSensor={sensor}
          cameraNumber={isSwap ? 2 : 1}
          isDisplayVideo={sensorData.typeDisplayCamera === "VIDEO"}
          isImageAnalysis={sensorData.imageAnalysisFeature}
          isInList
          label={isDoubleCamera ? `${sensor.name}_L` : sensor.name}
          style={{ width: 'unset' }}
          onClick={onClickSensor}
          imageProps={{
            key: isSwap ? sensorData.keyNewestImage2 : sensorData.keyNewestImage,
          }}
          buttonStatusProps={{
            status: {
              color: targetGroup.messages[isSwap ? sensorData.imageAnalysisLastFloodDetectedStatus_2 : sensorData.imageAnalysisLastFloodDetectedStatus_1]?.color,
              value: targetGroup.messages[isSwap ? sensorData.imageAnalysisLastFloodDetectedStatus_2 : sensorData.imageAnalysisLastFloodDetectedStatus_1]?.value
            },
            toolTipContent: isSwap ? sensorData.imageAnalysisResponse_2 : sensorData.imageAnalysisResponse_1
          }}
        />
        {/* Camera 2 */}
        {isDoubleCamera && (
          <CameraDisplayer
            targetSensor={sensor}
            cameraNumber={isSwap ? 1 : 2}
            isDisplayVideo={sensorData.typeDisplayCamera === "VIDEO"}
            isImageAnalysis={sensorData.imageAnalysisFeature}
            isInList
            label={`${sensor.name}_R`}
            style={{ width: 'unset' }}
            onClick={onClickSensor}
            imageProps={{
              key: isSwap ? sensorData.keyNewestImage : sensorData.keyNewestImage2,
            }}
            buttonStatusProps={{
              status: {
                color: targetGroup.messages[isSwap ? sensorData.imageAnalysisLastFloodDetectedStatus_1 : sensorData.imageAnalysisLastFloodDetectedStatus_2]?.color,
                value: targetGroup.messages[isSwap ? sensorData.imageAnalysisLastFloodDetectedStatus_1 : sensorData.imageAnalysisLastFloodDetectedStatus_2]?.value
              },
              toolTipContent: isSwap ? sensorData.imageAnalysisResponse_1 : sensorData.imageAnalysisResponse_2
            }}
          />
        )}
      </React.Fragment>
    }
    return <div className='sensor_detail_list_row_wrapper' onMouseEnter={() => onMouseEnterSensor(sensor)} onMouseLeave={onMouseLeaveSensor} onClick={() => { onClickSensor(sensor) }}>
      <div key={sensor.id} className='sensor_detail_list_row'>
        {
          HEADER
            .filter((item) => isValidationColumn(item))
            .map((item, index) => {
              if (item.id.startsWith('data') && props.sensorType !== SensorType.FLOOD_GATE && item.id !== 'data.powerVoltage') return null;
              if (item.id === 'status') {
                return (
                  <div
                    key={sensor.id + index}
                    className='sensor_detail_list_row_cell'
                    style={{
                      // maxWidth: item.width, 
                      justifyContent: item.id.includes('icon') ? 'center' : 'flex-start',
                      alignItems: 'flex-start'
                    }}>
                    <label
                      className={'card-info_value-text'}
                      style={{
                        background: statusColor,
                        color: statusColor ? hexToRGB(statusColor) >= 400 && 'black' : 'white',
                        minWidth: 'unset',
                        padding: '4px 8px'
                      }}>
                      {targetGroup?.messages[sensor.status]?.status}
                    </label>
                    {sensor.isLocked === LockState.LOCKED &&
                      generalSetting?.alertOn && <>
                        &nbsp;
                        <label className={'card-info_value-text'}
                          style={{
                            background: alertMessage?.color,
                            minWidth: 'unset',
                            padding: '4px 8px'
                          }}>
                          警報ラッチ
                        </label>
                      </>}
                  </div>
                )
              }
              if (item.id.includes('icon')) {
                return (
                  <div
                    key={index}
                    className='sensor_detail_list_row_cell'
                    style={{
                      // maxWidth: item.width,
                      justifyContent: 'center'
                    }}
                    onClick={handleClickIcon(sensor, item.id)}
                  >
                    {item.id === 'iconDelete' ? <FontAwesomeIcon icon={faTrash} /> : <img alt='icon' src={IconValue[item.id]} />}
                  </div>
                )
              }
              if (item.id.startsWith('data.') && sensorData) {
                if (item.id === SENSOR_PROPERTIES.FLOOD_GATE_OPENING_LEVEL) {
                  return <div
                    key={index}
                    className='sensor_detail_list_row_cell' >
                    {((sensorData[SENSOR_PROPERTIES.FLOOD_GATE_OPENING_LEVEL.slice(5)] || sensorData[SENSOR_PROPERTIES.FLOOD_GATE_OPENING_LEVEL] === 0) &&
                      sensorData[SENSOR_PROPERTIES.FLOOD_GATE_OPENING_LEVEL.slice(5)]?.toFixed(sensorData[SENSOR_PROPERTIES.FLOOD_GATE_OPENING_LEVEL_DISPLAY] || 0) || '') +
                      (sensorData[SENSOR_PROPERTIES.FLOOD_GATE_OPENING_UNIT.slice(5)] || '')}
                  </div>
                }
                if (item.id === SENSOR_PROPERTIES.INNER_WATER_LEVEL || item.id === SENSOR_PROPERTIES.OUTER_WATER_LEVEL) {
                  return <div
                    key={index}
                    className='sensor_detail_list_row_cell' >
                    {(sensorData[item.id.slice(5).replace('data.', '')]?.toFixed(2) || '') + 'm'}
                  </div>
                }
                if (item.id === SENSOR_PROPERTIES.POWER_VOLTAGE) {
                  return <div
                    key={index}
                    className='sensor_detail_list_row_cell' >
                    {
                      targetGroup.type === SensorType.GENERAL && sensorData.connectMethod === "SOCKET" ? UNDEFINED_TEXT :
                        (sensorData[SENSOR_PROPERTIES.POWER_VOLTAGE.slice(5)]?.toFixed(1) || '') + 'V'
                    }
                  </div>
                }
                return null;
              }
              if (item.id === SENSOR_PROPERTIES.MESSAGE) {
                return <div
                  key={index}
                  className='sensor_detail_list_row_cell' >
                  {targetGroup.messages[sensor.status]?.message?.replace(/%sensor/g, sensor.name)?.replace(/%place/g, sensor.location) || '-'}
                </div>
              }
              if (item.id === SENSOR_PROPERTIES.GROUP_ID) {
                return <div
                  key={index}
                  className='sensor_detail_list_row_cell' >
                  {SensorTypeName?.[targetGroup?.type]}
                </div>
              }
              return <div
                key={index}
                className='sensor_detail_list_row_cell'
                style={{
                  // 'maxWidth': item.width
                }}>
                {modifiedValue(sensor[item.id], item.id)}
              </div>
            })
        }
      </div>
      {quickViewItem && quickViewItem.id === sensor.id &&
        <div className='sensor_detail_quick_view_general_sensor'>
          <div >
            {Array.from({ length: 5 }).map((_, index) => {
              const nameSignal = quickViewItem.data[`nameSignal${4 - index}`];
              return nameSignal && <div className='sensor_detail_quick_view_general_sensor_item'>{quickViewItem.data[`nameSignal${4 - index}`]}</div>
            })}
            <div className='sensor_detail_quick_view_general_sensor_divider' />
            {Array.from({ length: 10 }).map((_, index) => {
              const nameContact = quickViewItem.data[`nameContact${9 - index}`];
              return nameContact && <div className='sensor_detail_quick_view_general_sensor_item'>{quickViewItem.data[`nameContact${9 - index}`]}</div>
            })}
          </div>
          <div>
            {Array.from({ length: 5 }).map((_, index) => {
              const nameSignal = quickViewItem.data[`nameSignal${4 - index}`];
              const decimalPartLength = quickViewItem.data?.[`decimalPartLength${4 - index}`] || 0;
              return nameSignal && <div className='sensor_detail_quick_view_general_sensor_item'>{(quickViewItem.data[`conversionFactorSignal${4 - index}`] * quickViewItem.data[`a${4 - index}`] + quickViewItem.data[`correctionCoefficientSignal${4 - index}`])?.toFixed(decimalPartLength)}</div>
            })}
            <div className='sensor_detail_quick_view_general_sensor_divider' />
            {Array.from({ length: 10 }).map((_, index) => {
              const nameContact = quickViewItem.data[`nameContact${9 - index}`];
              return nameContact && <div className='sensor_detail_quick_view_general_sensor_item'>{quickViewItem.data[`valueContact${9 - index}`] === "1" ? "通知" : "異常検知"}</div>
            })}
          </div>
          <div>
            {Array.from({ length: 5 }).map((_, index) => {
              const nameSignal = quickViewItem.data[`nameSignal${4 - index}`];
              return nameSignal && <div className='sensor_detail_quick_view_general_sensor_item'>{quickViewItem.data[`unitSignal${4 - index}`]}</div>
            })}
            <div className='sensor_detail_quick_view_general_sensor_divider' />
            {Array.from({ length: 10 }).map((_, index) => {
              const nameContact = quickViewItem.data[`nameContact${9 - index}`];
              return nameContact && <div className='sensor_detail_quick_view_general_sensor_item'>{quickViewItem.data[`s${9 - index}`] ? 'ON' : 'OFF'}</div>
            })}
          </div>
        </div>}
    </div>
  }
  /*** Event Handlers ***/
  const isValidationColumn = (item) => {
    return props.isManagementList ?
      item.role === ROLE.MANAGE || item.role === ROLE.GENERAL :
      item.role === ROLE.LIST || item.role === ROLE.GENERAL
  }
  const onClickSensor = useCallback((sensor, state) => {
    props.isManagementList ?
      props.onEditItem(sensor) :
      props.onViewItem(sensor, state);
  }, [props.sensor?.id, props.isManagementList])

  const onMouseEnterSensor = (sensor) => {
    if (props.sensorType !== SensorType.GENERAL) return;
    setQuickViewItem(sensor);
  }
  const onMouseLeaveSensor = () => {
    if (props.sensorType !== SensorType.GENERAL) return;
    setQuickViewItem(null);

  }
  const handleClickIcon = (sensor, key) => (e) => {
    e.stopPropagation();
    if (key === 'iconMail') {
      props.onSendMail(sensor);
    } else if (key === 'iconMap') {
      props.onFocusItem(sensor);
    }
    else if (key === 'iconDelete') {
      props.onDeleteItem(sensor);
    }
  }
  const onChangeOrderBy = (newOrderBy) => {
    if (orderBy === newOrderBy) {
      if (descDirections.includes(newOrderBy)) {
        setDescDirections(descDirections.filter(d => d !== newOrderBy));
      }
      else {
        descDirections.push(newOrderBy);
        setDescDirections(Object.assign([], descDirections));
      }
    }
    setOrderBy(newOrderBy);
  }
  /*** Main Render ***/
  return <BaseList
    items={sortedItems}
    renderHeader={renderHeader}
    renderItem={renderItem}
    curPage={props.curPage}
    onPageChange={props.onPageChange}
    itemNumPerPage={!props.isManagementList && props.sensorType === SensorType.CAMERA ? ITEM_NUM_PER_PAGE_CAMERA_SENSOR : ITEM_NUM_PER_PAGE}
    isNew={true}
    functionBtn={props.functionBtn}
    sensorType={props.sensorType}
    isManagementList={props.isManagementList}
  />
}





SensorDetailList.propTypes = propTypes;
SensorDetailList.defaultProps = defaultProps;
export default SensorDetailList;

const modifiedValue = (value, id) => {
  if (id === SENSOR_PROPERTIES.CREATEDAT) {
    return value ? value.split(' ')[0] : UNDEFINED_TEXT;
  }
  if (typeof value === 'string') {
    if (id === SENSOR_PROPERTIES.ID) {
      const modifiedValue = value.split('+')[0];
      return (modifiedValue === 'camera' || modifiedValue === 'socket') ? UNDEFINED_TEXT : modifiedValue;
    }
    return value.trim() ? value : UNDEFINED_TEXT;
  } else if (typeof value === 'number') {
    return value.toFixed(3);
  } else if (typeof value === 'undefined') {
    return UNDEFINED_TEXT;
  }
}